import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material/styles';

const Area = (props) => {
   const theme = useTheme();
   return (
      <SvgIcon {...props} viewBox="0 0 40 40">
         <g
            id="ITO-Design-System"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
         >
            <g
               id="area"
               transform="translate(-0.2369, 0)"
               fill={theme.palette.primary.main}
               fillRule="nonzero"
            >
               <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M30.3794 14.5247L26.7299 5.43441L30.3794 5.92845L34.0288 5.43441L30.3794 14.5247Z"
               />
               <path d="M12.132 22.1329L11.2936 22.6269L0.0144783 14.183L0.789076 13.6848L12.132 22.1329Z" />
               <path d="M40 16.5075L39.1085 17.0937L19.3963 2.39598L20.1709 1.89784L40 16.5075Z" />
               <path d="M20.1707 1.92675L20.7625 2.32198L0.789076 14.7717L0 14.1789L20.1707 1.92675Z" />
               <path d="M39.3932 16.1515L39.985 16.5467L20.0115 28.9965L19.2225 28.4036L39.3932 16.1515Z" />
               <path d="M28.3789 7.97555L29.1187 8.51899L26.1991 10.438L25.4086 9.84589L28.3789 7.97555Z" />
               <path d="M21.3637 12.4607L22.1034 13.0072L16.5822 16.491L15.7438 15.9475L21.3637 12.4607Z" />
               <path d="M11.5895 18.3288L12.3293 18.8722L9.75356 20.6503L8.96449 20.0574L11.5895 18.3288Z" />
               <path d="M19.3386 14.2788L18.8364 14.9655L10.1593 8.59789L10.6615 7.9112L19.3386 14.2788Z" />
               <path d="M20.8203 28.4883L20.0228 29L16.6334 26.4723L17.2579 25.8574L20.8203 28.4883Z" />
               <path d="M20.8203 28.4883L20.0228 29L16.6334 26.4723L17.2579 25.8574L20.8203 28.4883Z" />
               <path d="M32.1548 3.9523C32.1548 2.97004 31.3599 2.17376 30.3794 2.17376C29.3988 2.17376 28.6039 2.97004 28.6039 3.9523C28.6039 4.93456 29.3988 5.73083 30.3794 5.73083V7.9046C28.2004 7.9046 26.434 6.1351 26.434 3.9523C26.434 1.7695 28.2004 0 30.3794 0C32.5583 0 34.3247 1.7695 34.3247 3.9523C34.3247 6.1351 32.5583 7.9046 30.3794 7.9046V5.73083C31.3599 5.73083 32.1548 4.93456 32.1548 3.9523Z" />
            </g>
         </g>
      </SvgIcon>
   );
};
export default Area;
